export default __webpack_public_path__ + "static/media/cp_int_intune.512088be.svg";